import { ProductDtoAttributes } from "./Product"
import { MatrixItemsMapBuilder } from "./matrix/MatrixItemsMapBuilder"
import { MatrixItemDto } from "./matrix/matrix-item/MatrixItem"

export const ProvisionMatrixItems = (product: ProductDtoAttributes, createAsDeleted: boolean): MatrixItemDto[] => {
    const itemsMapBuilder = new MatrixItemsMapBuilder(product, createAsDeleted)
    itemsMapBuilder.Initialize()
    itemsMapBuilder.ProvisionExistingItems()

    return itemsMapBuilder.GetItems()
}

export const getCostByInventoryLocation = (product: ProductDtoAttributes, inventoryLocationId: string)  => {
    if (product.inventoryLocationEstimatedCosts) {
        const productCost = product.inventoryLocationEstimatedCosts
            .find(estimatedCost => estimatedCost.inventoryLocationId === inventoryLocationId)    

        return productCost?.estimatedCost
    }
}


// WEBPACK FOOTER //
// ./src/state/product/Utils.ts